"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../../store/store");
var legacy_1 = require("satcheljs/lib/legacy");
/**
 * Set the getInboxRuleRequestStatus in the inbox rules options store
 * @param requestStatus the get inbox rules request status to set
 * @param state the state which contains the store
 */
exports.default = legacy_1.action('setGetInboxRuleRequestStatus')(legacy_1.select({
    optionState: function () { return store_1.default.inboxRulesListState; },
})(function setGetInboxRuleRequestStatus(requestStatus, state) {
    var optionState = state.optionState;
    optionState.getInboxRuleRequestStatus = requestStatus;
}));
//# sourceMappingURL=setGetInboxRuleRequestStatus.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-inbox-rules-option/lib/actions/helpers/setGetInboxRuleRequestStatus.js
// module id = 5219
// module chunks = 2